"use strict";
import classNames from "classnames";
const types = {
  info: {
    iconClass: "icon-info",
    alertClass: "alert-box--highlight"
  }
};
export default React.createClass({
  propsTypes: {
    type: React.PropTypes.string,
    title: React.PropTypes.string.isRequired,
    body: React.PropTypes.string.isRequired,
    action: React.PropTypes.node
  },
  render: function() {
    const typeDetails = types[this.props.type] || types["info"];
    const alertClasses = classNames({
      [typeDetails.alertClass]: true,
      "alert-box--flex": true,
      "mb-1": true
    });
    const iconClasses = classNames({
      "icon": true,
      [typeDetails.iconClass]: true,
      "icon--no-repeat": true,
      "icon--sm": true,
      "mr-2": true
    });
    return /* @__PURE__ */ React.createElement("div", { className: alertClasses }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: iconClasses }), /* @__PURE__ */ React.createElement("span", { className: "mr-2" }, /* @__PURE__ */ React.createElement("strong", null, this.props.title)), /* @__PURE__ */ React.createElement("span", null, this.props.body)), this.props.action && /* @__PURE__ */ React.createElement("div", null, this.props.action));
  }
});
